import React from "react";
import SeoHead from "@/components/SeoHead";
import KnowledgeLibrarySection from "@/components/KnowledgeLibrarySection";

/* Knowledge Library — public catalog at /library.
 *
 * The full UI lives in <KnowledgeLibrarySection />. This wrapper just
 * adds the SEO meta + the page-level container so the same component
 * can also be embedded inside /education (the "Learn" page) without
 * duplicating any of the filter/grid logic.
 */
export default function Library() {
    return (
        <section
            data-clarity-unmask="true"
            className="container max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12"
            data-testid="library-page"
        >
            <SeoHead
                title="Knowledge Library — Memory Lane Care"
                description="Browse our full library of evidence-informed dementia caregiver guides — covering early-stage, middle-stage, and late-stage care, Medicare coverage, behaviors, safety, planning, and self-care for the caregiver."
                canonicalPath="/library"
            />
            <KnowledgeLibrarySection
                showHeader={true}
                testidPrefix="library"
                defaultCollapsed={false}
            />
        </section>
    );
}
